import { FC } from 'react'
import { MenuItem, TextField } from '@mui/material'
import { Oportunidade } from '@/types/oportunidade'

export interface OpcaoConsultor {
  id: string
  nome: string
}

/** Valor do filtro para "todos os consultores". */
export const TODOS_CONSULTORES = ''

/**
 * Consultores das reservas carregadas, com o nome gravado na reserva (V49, 14/10/2026),
 * ordenados pelo nome. Reserva antiga sem nome aparece pelo começo do id — nunca some do filtro.
 */
export const consultoresDasReservas = (reservas: Oportunidade[]): OpcaoConsultor[] => {
  const porId = new Map<string, string>()
  for (const r of reservas) {
    if (!r.usuarioResponsavel) continue
    const atual = porId.get(r.usuarioResponsavel)
    if (!atual || (r.consultorNome && atual.endsWith('…'))) {
      porId.set(r.usuarioResponsavel, r.consultorNome ?? `${r.usuarioResponsavel.slice(0, 8)}…`)
    }
  }
  return [...porId.entries()]
    .map(([id, nome]) => ({ id, nome }))
    .sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'))
}

/**
 * Filtro "Consultor" das abas de Operações e Clientes (relato de teste do usuário, 14/10/2026).
 * Com um consultor só (o próprio consultor logado, por exemplo) não há o que filtrar e o campo
 * não aparece.
 */
export const FiltroConsultor: FC<{
  opcoes: OpcaoConsultor[]
  valor: string
  onChange: (id: string) => void
}> = ({ opcoes, valor, onChange }) => {
  if (opcoes.length < 2) return null
  return (
    <TextField
      select
      size="small"
      label="Consultor"
      value={valor}
      onChange={(e) => onChange(e.target.value)}
      sx={{ minWidth: 220 }}
      SelectProps={{ MenuProps: { PaperProps: { sx: { maxHeight: 360 } } } }}
    >
      <MenuItem value={TODOS_CONSULTORES}>Todos os consultores</MenuItem>
      {opcoes.map((c) => (
        <MenuItem key={c.id} value={c.id}>
          {c.nome}
        </MenuItem>
      ))}
    </TextField>
  )
}

export default FiltroConsultor
